import React, {
    useEffect,
    useState
} from 'react';
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { addressReducer } from '../redux';
    

const Tracking = (addTracking) => {
    const location = useLocation()
    const nextPage = useSelector(state => state.navigationReducer.nextPage);
    const [lastTrack, setLastTrack] = useState('')
   

    useEffect(() => {
    
        if (addTracking) {
            let page = '';

            switch (nextPage) {
                case "/bookmeeting":
                    page = location.pathname === nextPage ? 'gecko page' : 'customer information gecko page';
                    break;
                case "/uploadpolicy":
                    page = location.pathname === nextPage ? 'intellitech page' : 'customer information intellitech page';
                    break;
                default:
                    page = location.pathname === '/' ? 'landing page' : ''
            }

            if(page && (page !== lastTrack)) {
                const script = document.createElement('script');

                script.type = "text/javascript";
                script.appendChild(document.createTextNode('_satellite.track("page view", {"page_name":"' + page + '"})'))
    
                document.body.appendChild(script);
    
                setLastTrack(page);
    
                return () => {
                    document.body.removeChild(script);
                }
            }
        }

   })
}

export default Tracking;

